import { CategoryBanner } from "@/components/storyblok/CategoryBanner"
import { ContactForm } from "@/components/storyblok/ContactForm"
import { ContentSection } from "@/components/storyblok/ContentSection"
import { FAQ } from "@/components/storyblok/FAQ"
import { FAQItem } from "@/components/storyblok/FAQItem"
import { SbHeroSlider } from "@/components/storyblok/HeroSlider"
import { SBImage } from "@/components/storyblok/Image"
import LegalPage from "@/components/storyblok/LegalPage"
import { LogoBanner } from "@/components/storyblok/LogoBanner"
import Page from "@/components/storyblok/Page"
import RichtText from "@/components/storyblok/Text"
import InfoBanner from "@/components/storyblok/InfoBanner"

export const componentMapping = {
  page: Page,
  hero_slider: SbHeroSlider,
  category_banner: CategoryBanner,
  image: SBImage,
  contact_form: ContactForm,
  logo_banner: LogoBanner,
  legal_page: LegalPage,
  faq: FAQ,
  faq_item: FAQItem,
  content_section: ContentSection,
  text: RichtText,
  info_banner: InfoBanner,
}
